import { render, staticRenderFns } from "./AvaliationTechnique.vue?vue&type=template&id=ee79742c&scoped=true"
import script from "./AvaliationTechnique.vue?vue&type=script&lang=js"
export * from "./AvaliationTechnique.vue?vue&type=script&lang=js"
import style0 from "./AvaliationTechnique.vue?vue&type=style&index=0&id=ee79742c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee79742c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRating,VRow,VSheet})
